import { OrderedMap } from 'immutable';
import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { ALERTS_REDUCER_KEY, type Alert } from './alertsTypes';

type State = Pick<RootState, ALERTS_REDUCER_KEY>;

export const getResourceStore = (state: State) => state[ALERTS_REDUCER_KEY];
export const getResourcesById = createSelector([getResourceStore], (s) => s.resourcesById);
export const getLoadPending = createSelector([getResourceStore], (s) => s.loadPending);
export const getIsLoading = createSelector([getResourceStore], (s) => s.isLoading);
export const getError = createSelector([getResourceStore], (s) => s.error);
export const getLastSyncDate = createSelector([getResourceStore], (s) => s.lastSyncDate);

export const getAlerts = createSelector(getResourcesById, (alerts) =>
  OrderedMap(alerts)
    .filter((alert) => {
      assert(alert, 'There should be no falsy items in the alert store.');

      return alert && !alert.isDismissed;
    })
    .sort((alert1, alert2) => (alert2.createdAt ?? '').localeCompare(alert1.createdAt ?? '')),
);

export const getAlertsUnread = createSelector(getAlerts, (alerts) => alerts.filter((alert) => !alert.isRead));

export const getAlertsUnreadCount = createSelector(
  [getAlertsUnread],
  (unreadAlerts): number => unreadAlerts?.size ?? 0,
);

export const getAlertsList = createSelector(getAlerts, (alerts): Alert[] => alerts.valueSeq().toArray());

export const getAlertsUnreadList = createSelector(getAlertsUnread, (alerts): Alert[] => alerts.valueSeq().toArray());
